import type { Column } from '../model/schema'

// Колонки приходят потребителям то списком доски, то картой по id (личная очередь
// резолвит колонки нескольких досок сразу) — правило «выполнена» обязано читаться
// из обеих форм, иначе оно расползётся по потребителям копиями. Из колонки правилу
// нужен только флаг: витрина заказчика знает про свои колонки меньше, а правило
// у неё то же самое.
interface DoneFlagColumn {
  id: string
  done: boolean
}

export type ColumnSource = readonly DoneFlagColumn[] | ReadonlyMap<string, DoneFlagColumn>

function isColumnMap(source: ColumnSource): source is ReadonlyMap<string, DoneFlagColumn> {
  return typeof (source as ReadonlyMap<string, DoneFlagColumn>).get === 'function'
}

function columnOf(source: ColumnSource, columnId: string): DoneFlagColumn | undefined {
  return isColumnMap(source) ? source.get(columnId) : source.find((c) => c.id === columnId)
}

// Задача выполнена ⟺ её колонка помечена флагом done. Единственное место правила:
// секции личной очереди, фильтры, тон срока, Гант и галочка «выполнено» спрашивают
// его, а не флаг колонки напрямую.
export function isTaskDone(task: { columnId: string | null }, columns: ColumnSource): boolean {
  if (!task.columnId) return false
  return columnOf(columns, task.columnId)?.done ?? false
}

// Первая done-колонка (по позиции) — куда галочка «выполнено» переносит задачу.
// Нет такой → отмечать нечем, чекбокс заблокирован.
export function firstDoneColumn(columns: readonly Column[]): Column | undefined {
  return [...columns].sort((a, b) => a.position - b.position).find((c) => c.done)
}

// Первая counts_time-колонка (по позиции) — куда take переносит задачу и стартует
// таймер. Нет такой → take вернёт 409 TASK_NO_TIME_COLUMN.
export function firstCountsTimeColumn(columns: Column[]): Column | undefined {
  return [...columns].sort((a, b) => a.position - b.position).find((c) => c.countsTime)
}

// Куда «Остановить» переносит задачу из counts_time: предпочитаем waiting-колонку
// («на паузе, ждём»), иначе первую не-counts_time и не-done по позиции.
export function stopColumn(columns: Column[]): Column | undefined {
  const candidates = [...columns]
    .sort((a, b) => a.position - b.position)
    .filter((c) => !c.countsTime)
  return candidates.find((c) => c.waiting) ?? candidates.find((c) => !c.done) ?? candidates[0]
}
